import { render, staticRenderFns } from "./communicationRecord.vue?vue&type=template&id=eff50fee&scoped=true"
import script from "./communicationRecord.vue?vue&type=script&lang=js"
export * from "./communicationRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff50fee",
  null
  
)

export default component.exports